import React from 'react';

export default function Logo(props){
    return(
        <div style={{textAlign:'center'}}>
            <img style={{maxHeight:300, maxWidth:300}} alt="BAF_Logo" src={`${window.location.origin}/BAF-Logo.svg`} />
            <h1>{props.name}</h1>
        </div>
    );
}